<ng-container *ngFor="let alert of alerts$ | async | perType:static:false; let index = index" >
    <sc-alert-message *ngIf="visible" 
        [data]="alert" 
        [@slide]="{ value: true, params: { width: 100, axis: 'Y', delay: 500*(index+1), duration: '0.3s' } }"
    ></sc-alert-message>
</ng-container>
<sc-alert-message 
    *ngFor="let alert of alerts$ | async | perType:static:true | perProduct"
    [static]="true" 
    [data]="alert"
></sc-alert-message>